import useFetchPublisherAggregateRevenue from "api/AdminReports/useFetchPublisherAggregateRevenue";
import RevenueReportPanel, { useRevenuePeriod } from "components/CurrencyRevenueReport/RevenueReportPanel";

export default function RevenueReport({ publisherId }) {
    const { period, setPeriod, query } = useRevenuePeriod();
    const result = useFetchPublisherAggregateRevenue({ ...query, model_type: "publisher" }, publisherId);
    return <RevenueReportPanel publisher {...{ result, period, setPeriod }} />;
}
